import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { subscriptionFormActionsV2 } from '../../../SubscriptionForm/SubscriptionFormV2Sagas'
import { SEPA_COUNTRIES } from '../../../SubscriptionForm/Common/constants'

const useIban = callbackBic => {
  const [bankInformation, setBankInformation] = useState({})
  const [validationResponse, setValidationResponse] = useState(null)
  const [ibanIsLoading, setIbanIsLoading] = useState(false)

  const dispatch = useDispatch()
  /* const updateBillingData = payload => {
    dispatch(updateBillingStoreData(payload))
  } */
  const ibanValidationResponse = response => {
    setIbanIsLoading(false)

    if (response.message === 'OK') {
      // updateBillingData({ bic: response.bic ?? '' })
      setBankInformation(response)
      callbackBic(response.bic ?? '')
      return true
    }
    // updateBillingData({ bic: '' })
    return false
  }
  const ibanValidationHandler = (ibanValue, providerId = 0) => {
    setBankInformation({})
    setValidationResponse(null)
    setIbanIsLoading(true)
    dispatch({
      type: subscriptionFormActionsV2.BILLING_IBAN_VALIDATION,
      ibanValue,
      providerId,
      callback: ibanValidationResponse,
      callbackError: error => {
        setIbanIsLoading(false)
        setValidationResponse({ error })
      },
    })
  }

  const checkIbanPrefixIsValid = ibanValue => {
    return !(
      ibanValue?.startsWith('GB') ||
      ibanValue?.startsWith('NL') ||
      ibanValue?.startsWith('LU') ||
      ibanValue?.startsWith('PL')
    )
  }
  const checkIbanPrefixIsNotGb = ibanValue => {
    return !ibanValue?.startsWith('GB')
  }
  const checkIbanIsFromSepaZone = ibanValue => {
    const countryCode = ibanValue?.substring(0, 2)?.toUpperCase()
    return SEPA_COUNTRIES.includes(countryCode)
  }
  const checkIbanIsValid = (bankInformationFromState, checkCountryIban, ibanValue) => {
    const bankData = bankInformationFromState ?? bankInformation

    if (checkCountryIban === true) {
      return checkIbanPrefixIsValid(ibanValue) && bankData?.message === 'OK'
    }
    return bankData?.message === 'OK'
  }

  return {
    ibanValidationHandler,
    validationResponse,
    bankInformation,
    ibanIsLoading,
    checkIbanIsValid,
    checkIbanPrefixIsValid,
    checkIbanPrefixIsNotGb,
    checkIbanIsFromSepaZone,
  }
}

export default useIban
